module.exports = __webpack_public_path__ + "media/customizations/ranchlife/back-colored-5d5fa4d9f8ef9444dcf3747697009e7c.jpg";